import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { takeFirst } from "~/features/app/utils";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { Grid } from "~/features/ui/grid";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type TwoColumnMediaBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  columns?: React.ReactNode[];
  getColumnKey?: (index: number) => React.Key;
  hasTopDivider?: boolean | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function TwoColumnMediaBlockView({
  anchor,
  columns = [],
  getColumnKey,
  hasTopDivider = true,
  mode = "light",
  sectionProps,
  theme = "white"
}: TwoColumnMediaBlockViewProps) {
  const themeStyle = getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  return <_StyledSection {...sectionProps} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[hasTopDivider && {
    "borderTopWidth": "1px"
  }, themeStyle.background, themeStyle.border]}>
      <Wrap mode={mode as Mode}>
        <_StyledDiv>
          <_StyledGrid $_css2={[{
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-y-reverse": "0",
            "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
            "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
          },
          "@media (min-width: 1024px)": {
            "> :not([hidden]) ~ :not([hidden])": {
              "--tw-divide-x-reverse": "0",
              "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
              "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))",
              "--tw-divide-y-reverse": "0",
              "borderTopWidth": "calc(0px * calc(1 - var(--tw-divide-y-reverse)))",
              "borderBottomWidth": "calc(0px * var(--tw-divide-y-reverse))"
            },
            "borderLeftWidth": "1px",
            "borderRightWidth": "1px"
          }
        }, themeStyle.border]}>
            {columns.map((column, index) => <_StyledDiv2 key={getColumnKey?.(index) || index}>
                <_StyledDiv3>{column}</_StyledDiv3>
              </_StyledDiv2>)}
          </_StyledGrid>
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-18i0u5k-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-18i0u5k-1"
})({
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
});
var _StyledGrid = _styled3(Grid).withConfig({
  componentId: "sc-sf-18i0u5k-2"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-18i0u5k-3"
})({
  "gridColumn": "1 / -1",
  "aspectRatio": "4/3",
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "gridColumn": "span 6 / span 6",
    "padding": "4rem"
  }
});
var _StyledDiv3 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "two-column-media___StyledDiv3",
  componentId: "sc-k699j4-0"
})({
  "position": "relative",
  "height": "100%",
  "width": "100%"
});